import {getQueryVariable} from "@/uitls/uitls"

export default class Platform {
  //app落地页
  static downUrl = "";
  static downUrlIos = "";
  static downUrlAndroid = "";
  static downUrlWebclip = "";
  static downMobileprovision = "";
  //当前使用的api接口域名
  static address = "";
  //客服的uid
  static serverId = 10011;
  //当前平台
  static client = "h5";
  //68
  static down68 = "";
  //是否关闭聊天
  static offChat = false;
  //发送直播间的间隔时间
  static chartSendTime = 0;
  //聊天字数限制
  static chatCharactersNum = 100;
  //如果是原生的首页，不需要连接socket
  static isSocket = true;

  static channel = 0  //0就是没有。

  static h5_play_url = 'https://bfh5.lives8.com'  //h5播放器。

  static from_invite_code = '' // 被邀请的邀请码, 从url获取

  static isLoginIM = false;

  // 是否为网页签或 WebView 内嵌环境
  static get standalone() {
    let webclip = getQueryVariable('webclip');
    if(webclip){
      return true;
    }
    return !!window.navigator['standalone'];
  }

}
